import { SERVER_URL } from "../consts";
import logger from "./Logger";

export const sendSMS = async (to, body) => {
  const data = [to, body];
  console.log("This is the data sent to the backend - ", data);
  let dataResponse;
  const queryString = data.map((obj) => `data=${encodeURIComponent(JSON.stringify(obj))}`).join("&");

  await fetch(`${SERVER_URL}/api/v1/notifications/send-sms?${queryString}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
  })
    .then(async (response) => {
      const jsonResponse = await response.json();
      logger.info("Response from sending SMS - ", jsonResponse);
      dataResponse = jsonResponse;
    })
    .catch((error) => console.error(error));
  return dataResponse;
};
